export const environment = {
  production: false,
  allowDynamicBaseUrl: false,
  RedirectURL: 'https://survey.krimansresearch.com/3Mj4eXMf565PoJ/api-route/',
  isKrimans: true,
  httpOptions: {
    'Authorization': 'Token ' + (localStorage.getItem('userToken') || ''),
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;',
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    'Pragma': 'no-cache',
    'Expires': '0',
    "Allow": "GET, POST, PUT, DELETE, OPTIONS",
    "Vary": "Accept"
  },
  requestOptions: {
    'Content-Type': 'application/json',
    "accept": "application/json"
  }
};
